import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Featured from "../components/Featured";
import blue_bg from "../assets/blue-bg.png";
import crich_church_background_wide_no_logo from "../assets/crich-church-outside-bg-wide-no-logo.png";
import crich_church_lawn from "../assets/crich_church_lawn.png";
import crich_church_tall from "../assets/crich_church_tall.png";
import { firestore, collection, query, orderBy, getDocs } from "../firebase-config";
import "../styles/Layout.css";

const homeMediaData = [
  { type: "youtube", src: "WOFbgn4HTic" },
];

const Layout = ({ children, featureType }) => {
  const [latestSermon, setLatestSermon] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (featureType === "online_sermons") {
      const fetchLatest = async () => {
        try {
          const sermonsQuery = query(
            collection(firestore, "sermons"),
            orderBy("date", "desc")
          );
          const snapshot = await getDocs(sermonsQuery);
          if (!snapshot.empty) {
            const doc = snapshot.docs[0];
            setLatestSermon({ id: doc.id, ...doc.data() });
          }
        } catch (err) {
          console.error("Error fetching latest sermon:", err);
        }
      };
      fetchLatest();
    }
  }, [featureType]);

  const getYouTubeId = (url) => {
    if (!url) return null;
    const match = url.match(
      /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/))([^&?/\s]{11})/
    );
    return match ? match[1] : null;
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return "";
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  const getSermonThumbnail = (sermon) => {
    if (sermon.thumbnailUrl) return sermon.thumbnailUrl;
    const ytId = getYouTubeId(sermon.youtubeUrl);
    if (ytId) return `https://img.youtube.com/vi/${ytId}/mqdefault.jpg`;
    return null;
  };

  const latestSermonCard = latestSermon ? (
    <div
      className="featured-sermon-card"
      onClick={() => navigate(`/online-sermons/${latestSermon.id}`)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          navigate(`/online-sermons/${latestSermon.id}`);
        }
      }}
    >
      <div className="featured-sermon-thumb">
        <img src={crich_church_tall} alt="Crich Baptist Church" />
      </div>
      <div className="featured-sermon-info">
        <span className="featured-sermon-label">Latest Sermon</span>
        <h3 className="featured-sermon-title">{latestSermon.title}</h3>
        <p className="featured-sermon-meta">
          {latestSermon.speaker} • {formatDate(latestSermon.date)}
        </p>
        {latestSermon.scripture && (
          <p className="featured-sermon-scripture">{latestSermon.scripture}</p>
        )}
      </div>
    </div>
  ) : null;

  return (
    <div className="layout">
      {featureType === "home" && (
        <Featured title="Welcome to Crich Baptist Church" media={homeMediaData} backgroundImage={crich_church_background_wide_no_logo} titleColour="#ffffff" isHero />
      )}
      {featureType === "about_us" && (
        <Featured title="About Us" backgroundImage={blue_bg} titleColour="#ffffff" />
      )}
      {featureType === "ministries" && (
        <Featured title="Ministries" backgroundImage={blue_bg} titleColour="#ffffff" />
      )}
      {featureType === "blog" && (
        <Featured title="Blog" backgroundImage={blue_bg} titleColour="#ffffff" />
      )}
      {featureType === "online_sermons" && (
        <Featured
          title="Online Sermons"
          backgroundImage={crich_church_lawn}
          titleColour="#ffffff"
          isHero
          customContent={latestSermonCard}
        />
      )}
      {featureType === "sermon_detail" && (
        <Featured
          title="Online Sermons"
          backgroundImage={crich_church_lawn}
          titleColour="#ffffff"
          isHero
        />
      )}
      {featureType === "resources" && (
        <Featured title="Resources" backgroundImage={blue_bg} titleColour="#ffffff" />
      )}
      {featureType === "statement-of-faith" && (
        <Featured title="Statement of Faith" backgroundImage={blue_bg} titleColour="#ffffff" />
      )}
      {featureType === "constitution" && (
        <Featured title="Church Constitution" backgroundImage={blue_bg} titleColour="#ffffff" />
      )}
      {featureType === "contact_us" && (
        <Featured title="Contact Us" backgroundImage={blue_bg} titleColour="#ffffff" />
      )}

      <div className="content-container">
        <main className="main-content">{children}</main>
        <Sidebar />
      </div>
    </div>
  );
};

export default Layout;
